import { Link, Typography } from "@material-ui/core";
import React from "react";
import { Link as RouterLink } from 'react-router-dom'

import { Collections } from "Collections";
import { FullscreenLoading } from "components/FullscreenLoading";
import { FirebaseUtils } from "firebaseUtils/FirebaseUtils";
import { AnalyticsEvent } from "models/AnalyticsEvent";
import { Offer } from "models/Offer";
import { Paths } from "Paths";
import { EmptyPage } from "screens/EmptyPage";

import { CreateOffer } from "./CreateOffer/CreateOffer";

type Props = {
    offerId: string
}

export function DraftOfferScreen({ offerId }: Props) {
    const [offer, loadingOffer] = FirebaseUtils.useDocumentData<Offer>(
        true,
        Collections.OFFER_DRAFTS,
        offerId,
        AnalyticsEvent.GET_OFFER_DRAFT_ERROR
    )

    const loading = loadingOffer

    if (loading) {
        return <FullscreenLoading screenId="DraftOffer" />
    }

    if (!offer) {
        return (
            <EmptyPage>
                <Typography align="center">{<>
                    Utkastet finnes ikke. Hvis anbudet har blitt sendt kan du finne det
                    <Link component={RouterLink} to={Paths.OFFER + '/' + offerId}> her</Link>
                </>}</Typography>
            </EmptyPage >
        )
    }

    return (
        <CreateOffer offer={offer.data} offerDoc={offer} path={Paths.OFFER_DRAFTS + '/' + offer.data.id} />
    )
}